// extracted by mini-css-extract-plugin
export default {"formLogin":"style_formLogin__7A-UZ","formPhoto":"style_formPhoto__3Y5TT"};